import {
    IComponentController,
    IComponentOptions,
    IOnChangesObject,
    IScope,
} from 'angular';
import {
    IFunctionBinding,
    IVFAxisDefinition,
    VFCustomAxes,
} from '../../../classes';

export interface IVariableAxisSliderComponentOnChanged {
    value?: number;
}

export class VariableAxisSliderComponent implements IComponentController {
    axisDefinition?: IVFAxisDefinition;
    axis?: VFCustomAxes;
    value?: number;
    onChanged?: IFunctionBinding<IVariableAxisSliderComponentOnChanged>;
    _selectedValue?: number = this.axisDefinition?.default;
    _extent?: number;
    _min?: number;
    _max?: number;

    static $inject = ['$scope'];
    constructor(protected $scope: IScope) {}

    $onInit(): void {
        // our range slider component doesn't offer an update hook, so we need to watch
        this.$scope.$watchCollection(
            () => this._selectedValue,
            () => this.sliderChanged()
        );
    }

    $onChanges(changes: IOnChangesObject): void {
        // console.log('VariableAxisSliderComponent.$onChanges', changes);
        if (changes.axisDefinition && this.axisDefinition !== undefined) {
            this._selectedValue = changes.axisDefinition.currentValue.default;
            this._extent = this.axisDefinition.max - this.axisDefinition.min;
            this._min =
                this._extent <= 1
                    ? this.axisDefinition.min * 100
                    : this.axisDefinition.min;
            this._max =
                this._extent <= 1
                    ? this.axisDefinition.max * 100
                    : this.axisDefinition.max;
        }
        if (changes.value && this.value !== undefined) {
            this._setValue();
        }
    }

    _setValue(): void {
        // I tried setting step on the range slider to 0.01, but that didn't work... so I'm scaling the value instead.
        const scaledValue =
            this._extent != undefined &&
            this._extent <= 1 &&
            this.value != undefined
                ? this.value * 100
                : this.value;
        if (this._selectedValue != scaledValue) {
            this._selectedValue = scaledValue;
        }
    }

    _getValue(): number | undefined {
        // I tried setting step on the range slider to 0.01, but that didn't work... so I'm scaling the value instead.
        const scaledValue =
            this._selectedValue !== undefined &&
            this._extent != undefined &&
            this._extent <= 1
                ? this._selectedValue / 100
                : this._selectedValue;
        return scaledValue;
    }

    sliderChanged(): void {
        const value = this._getValue();
        const eventArgs = { value };
        // console.log('VariableAxisSliderComponent.sliderChanged', this._selectedValue, eventArgs);
        this.onChanged && this.onChanged(eventArgs);
    }
}

export const VariableAxisSliderComponentOptions: IComponentOptions = {
    controller: VariableAxisSliderComponent,
    bindings: {
        axisDefinition: '<',
        // options, will be used in place of the axis name for the label.
        label: '<',
        value: '<?',
        onChanged: '&',
    },
    template: `
    <div class="variable-axis-slider" ng-if="$ctrl._selectedValue !== undefined">
        <label>{{$ctrl.label || $ctrl.axisDefinition.name}}</label>
        <div
            range-slider
            class="value-slider"
            min="$ctrl._min"
            max="$ctrl._max"
            step="1"
            model-max="$ctrl._selectedValue"
            pin-handle="min"
        ></div>
    </div>
`,
};
